'use strict'
const urlParse = require('url-parse')

class CommonConfig {
  constructor () {
    const url = urlParse(window.location.href)
    this.urlApi = process.env.NODE_ENV === 'development' ? 'http://test.smartix.team/dashboard/v1/' : ''
    if (process.env.NODE_ENV === 'development') {
      this.wsApi = 'ws://127.0.0.1:8080/equeue/app/dashboard/ws'
    } else {
      const ctx = url.href.split('#')[0].replace('/index.html', '').replace(url.protocol, '')
      this.wsApi = `${getWsProtocol(url.protocol)}${ctx}/ws`
    }
  }

  getUrlApi () {
    return this.urlApi
  }

  getWsApi () {
    return this.wsApi
  }
}

const getWsProtocol = (urlProtocol) => {
  if (urlProtocol === 'https:') {
    return 'wss:'
  } else {
    return 'ws:'
  }
}

export default new CommonConfig()
